import React from 'react';
import { hot } from 'react-hot-loader';
import BSContainer from 'react-bootstrap/Container';

import styles from './styles.module.css';

const Container = ({ children }) => {
  return <BSContainer className={styles.container} >{children}</BSContainer>
};

export default hot(module)(Container);
